const UPDATE_HEADER_TITLE = "@wevo/aurora/title/UPDATE_HEADER_TITLE";
const CLEAR_HEADER_TITLE = "@wevo/aurora/title/CLEAR_HEADER_TITLE";

/**
 * Creates a Redux action that, when dispatched, changes the page title & app header to `newTitle`
 * @param newTitle the new page title.
 * @param newIcon a FontAwesome icon string
 * @return the Redux action object.
 */
export function setPageTitle(newTitle, newIcon) {
    return {
        type: UPDATE_HEADER_TITLE,
        payload: {
            text: newTitle,
            icon: newIcon
        }
    };
}

export function clearPageTitle() {
    return {
        type: CLEAR_HEADER_TITLE
    };
}

/**
 * The Redux reducer for the
 * @param state
 * @param action
 * @returns {string}
 */
const initialState = { text: "", icon: "" };
export default function title(state = initialState, action) {
    switch (action.type) {
        case UPDATE_HEADER_TITLE:
            return {
                ...state,
                ...action.payload
            };
        case CLEAR_HEADER_TITLE:
            return initialState;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/title.js